import { Routes, Router } from '@angular/router';
import { provideRouter } from '@angular/router';
import { inject } from '@angular/core';
import {
  CreateUserComponent, LoginComponent, DashboardComponent, HomeComponent,
  PropertiesComponent, CreatePropertyComponent, CreatePropertyCategoryComponent, AmenitiesComponent, PropertyCategoryListingComponent,
  CreateAmenityComponent,
  AmenityCategoryListingComponent,
  CreateTenantsComponent,
  FollowupsComponent,
  NotFoundComponent,
  ChatbotComponent
} from './components';
import { CreateAmenityCategoryComponent } from './components/amenities/create-amenity-category/create-amenity-category.component';
import { AuthGuard } from './core/guards/auth.guard';
import { UsersComponent } from './components/users/users.component';
import { TenantsComponent } from './components/tenants/tenants.component';
import { FloorPlanListingComponent } from './components/floor-plans/floor-plan-listing/floor-plan-listing.component';
import { UnitsListingComponent } from './components/units/units-listing/units-listing.component';
import { TenantsPortalComponent } from './components/tenants-portal/tenants-portal.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChatLogsComponent } from './components/chat-logs/chat-logs.component';
import { TemplatesComponent } from './components/templates/templates.component';
import { TourAcceptComponent } from './components/tour-verification/tour-accept.component';
import { PropertyInfoComponent } from './components/properties/property-info/property-info.component';
import { PromptComponent } from './components/properties/prompts/prompts.component';
import { TourListingComponent } from './components/tour-listing/tour-listing.component';
import { ManageTourComponent } from './components/manage-tours/manage-tours.component';
import { AvailabilityComponent } from './components/properties/availability/availability.component';
import { ScheduleTourComponent } from './components/schedule-tour/schedule-tour.component';
import { ImpersonateLoginComponent } from './components/impersonate-login/impersonate-login.component';
import { FaqManagementComponent } from './components/properties/faq-management/faq-management.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { TenantGuard } from './core/guards/tenant.guard';
import { AvailabilityReportsComponent } from './components/availability-reports/availability-reports.component';
import { TenantSettingsComponent } from './components/tenant-settings/tenant-settings.component';
import { CrmComponent } from './components/crm/crm.component';
import { SmsTestComponent } from './components/sms-test/sms-test.component';
import { GuestCardsComponent } from './components/yardi/guest-cards/guest-cards.component';

const redirectIfAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  return token ? inject(Router).createUrlTree(['/dashboard']) : true;
};

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '404', component: NotFoundComponent },
  { path: 'login', component: LoginComponent, canActivate: [redirectIfAuthenticated] },
  { path: 'impersonate-login', component: ImpersonateLoginComponent },
  { path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'create-user', component: CreateUserComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  // { path: 'dashboard', component: DashboardComponent,  canActivate: [AuthGuard] },
  { path: 'floor-plans', component: FloorPlanListingComponent, canActivate: [AuthGuard] },
  { path: 'properties', component: PropertiesComponent, canActivate: [AuthGuard] },
  { path: 'property-info', component: PropertyInfoComponent, canActivate: [AuthGuard] },
  { path: 'faq-management', component: FaqManagementComponent, canActivate: [AuthGuard] },
  { path: 'prompts', component: PromptComponent, canActivate: [AuthGuard] },
  { path: 'create-property', component: CreatePropertyComponent, canActivate: [AuthGuard] },
  { path: 'property-categories', component: PropertyCategoryListingComponent, canActivate: [AuthGuard] },
  { path: 'create-property-category', component: CreatePropertyCategoryComponent, canActivate: [AuthGuard] },
  { path: 'amenities', component: AmenitiesComponent, canActivate: [AuthGuard] },
  { path: 'create-amenity', component: CreateAmenityComponent, canActivate: [AuthGuard] },
  { path: 'amenity-categories', component: AmenityCategoryListingComponent, canActivate: [AuthGuard] },
  { path: 'create-amenity-category', component: CreateAmenityCategoryComponent, canActivate: [AuthGuard] },
  { path: 'create-tenants', component: CreateTenantsComponent, canActivate: [AuthGuard] },
  { path: 'tenants', component: TenantsComponent, canActivate: [AuthGuard] },
  { path: 'followups', component: FollowupsComponent, canActivate: [AuthGuard] },
  { path: 'units-listing', component: UnitsListingComponent, canActivate: [AuthGuard] },
  { path: 'tenants-portal', component: TenantsPortalComponent, canActivate: [AuthGuard, TenantGuard] },
  { path: 'chat-bot-logs', component: ChatLogsComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'templates/:type', component: TemplatesComponent, canActivate: [AuthGuard] },
  { path: 'availability', component: AvailabilityComponent, canActivate: [AuthGuard] },
  { path: 'reports', component: AvailabilityReportsComponent, canActivate: [AuthGuard] },
  { path: 'sms-test', component: SmsTestComponent, canActivate: [AuthGuard] },
  { path: 'tenant-settings', component: TenantSettingsComponent, canActivate: [AuthGuard, TenantGuard] },
  // ✅ Add this route (even empty) to prevent 404
  { path: 'tour-verify/:userId/:tourId/:token', component: TourAcceptComponent },
  { path: 'chatbot', component: ChatbotComponent },
  { path: 'manage-tours', component: ManageTourComponent },
  { path: 'schedule/tour', component: ScheduleTourComponent },
  { path: 'gallery/:token', component: GalleryComponent },
  { path: 'crm', component: CrmComponent, canActivate: [AuthGuard] },
  { path: 'guest-cards', component: GuestCardsComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '404' }
];

export const appRoutingProviders = [provideRouter(routes)];
